
















import { Component, Vue } from 'vue-property-decorator';
import { Mentionable } from 'vue-mention';

@Component({
    components: {
        Mentionable,
    },
})
export default class ChatMessageInput extends Vue {
    public message: any = '';
    public text: string = '';

    get conversationParticipants() {
        const comment = this.$store.getters['Comments/getComments'];

        if (!comment) {
            return [];
        }

        let participants: any = [];

        if (comment.participants) {
            participants = comment.participants.map((item: any) => {
                return {
                    id: item.userId,
                    value: [item.firstName.toLowerCase(), item.familyName.toLowerCase()].join('_'),
                    label: `${item.firstName} ${item.familyName}`,
                    searchText: [item.firstName.toLowerCase(), item.familyName.toLowerCase()].join('_'),
                };
            });
        }

        return participants;
    }

    public sendMessage() {
        const mentionedUsers: any = [];

        this.conversationParticipants.forEach((item: any) => {
            if (this.message.includes(`@${item.value}`)) {
                mentionedUsers.push(item.id);
                this.message = this.message.replaceAll(`@${item.value}`, `<b data-mention-id="${item.id}" class="mentioned-item">@${item.label}</b>`);
            }
        });

        this.$emit('sendMessage', this.message);
        this.message = '';
    }
}
